var map = {
	"./conditional-form/1.jpg": "49ed",
	"./kid-a/1.jpg": "9481",
	"./nouveau-frissons/1.jpg": "ed8e",
	"./platform-x/1.jpg": "0dd7",
	"./sly-fox/1.jpg": "7770",
	"./we-are-unicorn/1.jpg": "c069"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e06f";